// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4c1d3af4","53":"b247a87d","249":"7bd12857","335":"8505c1bd","406":"8c0f551d","767":"aed83d5b","816":"51c94ba1","873":"10a64d70","925":"699d9779"}[chunkId] + ".chunk.js";
};